import { types } from 'mobx-state-tree';

import orderStatusTranslation from 'js/config/orderStatusTranslation';

export default types
  .model('OrderStatus', {
    id: types.number,
    creator_email: types.maybeNull(types.string),
    creator_name: types.string,
    status: types.string,
    created_at: types.string,
  })
  .views(self => ({
    get human_status() {
      return orderStatusTranslation[self.status] || `Unknown (${self.status})`;
    },
  }));
